import { EXTERNAL_FILE_REQUEST_STATUS } from "../../Data/SD";
import { ApproveRejectUploadedExternalFileReq, CreateExternalFileRequestDto, ExternalFileRequestDto, ExternalFileRequestTokenValiationRequest, ExternalFileRequestTokenValiationResponse, GetAllExternalFileRequestsDto } from "../../interfaces/ExternalFileReqeustDtos/externalFileRequestDtos";
import { ApiResponse, PagedResults } from "../../interfaces/genericResponse/GenericResponse";
import { apiPost, apiPut } from "../../utilities/api-client/apiRequest";

export async function CreateExternalFileRequestAsync(
    authToken: string,
    payload: CreateExternalFileRequestDto,    // this is the shared table id
): Promise<ApiResponse<boolean>> {
    const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/external-file-request/create-request`;

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload)
        });

        const result = await response.json();
        return result;
    } catch (err) {
        throw err;
    }
}

export async function ExternalFileRequestValidateTokenAsync(
    payload: ExternalFileRequestTokenValiationRequest,    // this is the shared table id
): Promise<ApiResponse<PagedResults<ExternalFileRequestTokenValiationResponse>>> {
    const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/external-file-request/token-validation`;

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                // Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload)
        });

        const result = await response.json();
        return result;
    } catch (err) {
        throw err;
    }
}

export async function UploadExternalFileAsync(
    file: File,
    token: string,
    externalFileReqeustId: string,
    uploaderIp: string
): Promise<ApiResponse<boolean>> {
    const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/external-file-request/UploadExternalFile`;

    try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("token", token);
        formData.append("externalFileReqeustId", externalFileReqeustId);
        formData.append("uploaderIp", uploaderIp);

        const response = await fetch(apiUrl, {
            method: "POST",
            body: formData,
            // ⚠️ Do NOT set Content-Type header manually; FormData handles it automatically.
        });

        const result = await response.json();
        return result;
    } catch (err) {
        console.error("UploadExternalFileAsync Error:", err);
        throw err;
    }
}

export async function GetAllExternalFileRequestAsync(
    authToken: string,
    payload: GetAllExternalFileRequestsDto,    // this is the shared table id
): Promise<ApiResponse<PagedResults<ExternalFileRequestDto>>> {
    const apiUrl: string = `/external-file-request/GetAllExternalFileRequests`;

    const res = apiPost<ApiResponse<PagedResults<ExternalFileRequestDto>>, GetAllExternalFileRequestsDto>(
        apiUrl, payload, authToken
    )
    return res;
}

export async function RevokeExternalFileRequestAsync(
    authToken: string,
    externalFileRequestId: string,    // this is the shared table id
): Promise<ApiResponse<boolean>> {
    const apiUrl: string = `/external-file-request/${externalFileRequestId}/RevokeExternalFileRequest`;

    const res = apiPut<ApiResponse<boolean>>(apiUrl, undefined, authToken);
    return res
}

export async function ApproveRejectUploadedExternalFileAsync(
    authToken: string,
    payload: ApproveRejectUploadedExternalFileReq,    // this is the shared table id
): Promise<ApiResponse<boolean>> {
    const apiUrl: string = `/external-file-request/ApproveRejectUploadedExternalFile`;

    const res = apiPost<ApiResponse<boolean>, ApproveRejectUploadedExternalFileReq>(apiUrl,  payload, authToken);

    return res;
}


export async function GetUploadedExternalFileRequestsAsync(
    authToken: string,
    pageNumber: number,
    pageSize: number,
    searchTerm?: string,
    sortBy?: string | null,
    sortDirection?: string | null
): Promise<ApiResponse<PagedResults<ExternalFileRequestDto>>> {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/Cir/external-file-requests/uploaded`;
    
    const queryParams = new URLSearchParams({
        pageNumber: pageNumber.toString(),
        pageSize: pageSize.toString(),
    });

    if (searchTerm) {
        queryParams.append("searchTerm", searchTerm);
    }
    if (sortBy) {
        queryParams.append("sortBy", sortBy);
    }
    if (sortDirection) {
        queryParams.append("sortDirection", sortDirection);
    }

    const fullUrl = `${apiUrl}?${queryParams.toString()}`;

    try {
        const response = await fetch(fullUrl, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to fetch uploaded external file requests: ${errorText}`);
        }

        const result = await response.json();
        return result;
    } catch (err) {
        console.error("GetUploadedExternalFileRequestsAsync Error:", err);
        throw err;
    }
}

export async function downloadFileInNewTabAsync(
    authToken: string,
    blobPath: string
): Promise<void> {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/external-file-request/download-file?blobPath=${encodeURIComponent(
        blobPath
    )}`;

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to download file: ${errorText}`);
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        // Open in new tab
        const newTab = window.open(url, "_blank");
        if (!newTab) {
            alert("Please allow popups for this website to open the file.");
        }

        // Optional: revoke object URL after a short delay
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 1000);
    } catch (err) {
        console.error(err);
        alert((err as Error).message);
    }
}
